import React from 'react'
import {StepsTable} from "../../../Data/Data"
import "./StepsToBook.css"
import { useTranslation } from 'react-i18next'


const StepsToBook = () => {
  const {t}=useTranslation();
  return (
    <div className='Steps-to-book-container pb-md-3 pb-sm-0 mb-lg-5 mb-4 container'>
      <h2 className='mb-3 mt-4'>{t("steps.titre")}</h2>
        <div className='row'>
            {StepsTable.map((icon, index) => {
              return (
                <>
                 <div key={index}  className='align-items-start Steps-icons-container py-0 col-lg-3 col-md-12 '>
                  <div className='row h-100 p-2'>
                        <div className='Steps-icons-container-ul d-flex flex-column align-items-start p-2 gap-3'>
                        <div className="col-auto">                  
                          <img src= {icon.src} alt="icons"/>
                        </div>
                      <div className='Steps-icons-container col'>
                          <h3 className='m-0 mb-2'>{t(`steps.${icon.count}`)}</h3>
                          <p>{t(`steps.${icon.content}`)}</p>
                      </div>
                    </div>
                  </div>    
                  </div>
                </>
              );
            })}
        </div>
    </div>
  )
}
export default StepsToBook
